import { type ChannelReads, api } from '@here/api'

export const handleGetChannelReads = async (userId: string) => {
	const { data } = await api().from('channel_reads').select('*').eq('user_id', userId)

	return data || []
}

export const whenChannelSeen = async (
	userId?: string,
	channelRead?: Partial<ChannelReads>,
) => {
	if (
		!userId ||
		!channelRead?.channel_id ||
		!channelRead.last_read_message_id
	)
		return

	await api().from('channel_reads').upsert({
		user_id: userId,
		channel_id: channelRead.channel_id!,
		last_read_message_id: channelRead.last_read_message_id!,
		is_subscribed: channelRead.is_subscribed,
		last_read_at: new Date().toISOString(),
	})
}
